import { SUPPORT_URL } from '@mote/helpers/constants'
import { Button, Text } from '@mote/ui'
import { GenericRecorderErrorsTemplate } from './GenericRecorderErrorsTemplate'

export const UnknownError = ({ onClose }) => {
  return (
    <GenericRecorderErrorsTemplate
      onClose={onClose}
      header='Oh dear'
      content={
        <Text fontSize={15} lineHeight='120%' fontWeight={400}>
          Whoops - something went wrong. Please try again, or search our FAQ
          pages for troubleshooting suggestions.
        </Text>
      }
      buttons={
        <>
          <Button
            onClick={() => onClose()}
            variant='secondary'
            text='Dismiss'
          />
          <Button
            onClick={() => {
              window.open(SUPPORT_URL, '_blank')
            }}
            text='Learn more'
          />
        </>
      }
    />
  )
}
